var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "User",

    getDefaultProps () {
        return {"width":"17px","height":"23px","viewBox":"0 0 17 23","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>E451CF20-FC16-448B-B5C5-E4B7202540B2</title>
  <desc>Created with sketchtool.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="symbol-user" fill="currentColor">
      <g id="user">
        <path d="M17,19.6153787 C17,14.9206447 13.1950563,11.1153846 8.5,11.1153846 C3.80832876,11.1153846 0,14.9245236 0,19.6114922 L0,22.1771947 C0,22.5383039 0.292736894,22.8310408 0.653846154,22.8310408 C1.01495541,22.8310408 1.30769231,22.5383039 1.30769231,22.1771947 L1.30769231,19.6114922 C1.30769231,15.6466799 4.53060956,12.4230769 8.5,12.4230769 C12.4728134,12.4230769 15.6923077,15.6428389 15.6923077,19.6153787 L15.6923077,22.1733023 C15.6923077,22.5344115 15.9850446,22.8271484 16.3461538,22.8271484 C16.7072631,22.8271484 17,22.5344115 17,22.1733023 L17,19.6153787 L17,19.6153787 Z M13.0769231,4.57692308 C13.0769231,2.04915826 11.0277648,0 8.5,0 C5.97223518,0 3.92307692,2.04915826 3.92307692,4.57692308 C3.92307692,7.10468789 5.97223518,9.15384615 8.5,9.15384615 C11.0277648,9.15384615 13.0769231,7.10468789 13.0769231,4.57692308 L13.0769231,4.57692308 Z M8.5,1.30769231 C10.3055463,1.30769231 11.7692308,2.77137678 11.7692308,4.57692308 C11.7692308,6.38246937 10.3055463,7.84615385 8.5,7.84615385 C6.6944537,7.84615385 5.23076923,6.38246937 5.23076923,4.57692308 C5.23076923,2.77137678 6.6944537,1.30769231 8.5,1.30769231 Z" id="Rectangle-873"/>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/user.svg
 **/